import React, { useContext } from "react";
import Helmet from "react-helmet";
import LessonSlideShow from "@src/components/ideas/LessonSlideShow";
import { getSearchParams } from "gatsby-query-params";
import { logEvent } from "@src/utils/logClient";
import { AppDataContext } from "@src/components/AppDataContext";

const Lesson = ({ pageContext }) => {
  const appData = useContext(AppDataContext);

  const lesson = pageContext.lesson;
  const searchParams = getSearchParams();

  return (
    <div>
      <Helmet>
        <title>{lesson.title} - Big Ideas - Classdojo</title>
        <script src="https://static.classdojo.com/radiant-media-player/js/rmp.min.js" key="rmp" />
      </Helmet>
      <LessonSlideShow
        lesson={lesson}
        params={searchParams}
        tab={pageContext.tab}
        logEvent={logEvent}
        user={appData.data.userData}
        classes={appData.data.classes}
        shareStatus={appData.data.shareStatus}
        shareToClassStory={appData.data.services.shareToClassStory}
      />
    </div>
  );
};

export default Lesson;
